import React from 'react'
import Layout from '../components/Layout'
import RoundContainer from '../components/RoundContainer'

export default function privacy() {
  return (
    <Layout>
      <RoundContainer>
        <h3>Privacy Policy</h3>
        <h4 style={{ textAlign: 'left' }}>Google Analytics</h4>
        <p style={{ textAlign: 'left' }}>
          We use Google Analytics, which is Google’s analytics tool that helps
          websites to understand how their visitors engage with their web
          properties. It may use a set of cookies to collect information and
          report website usage statistics without personally identifying
          individual visitors. The main cookie used by Google Analytics is the
          ‘_ga’ cookie. See{' '}
          <a href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage">
            Analytics cookies and privacy information.
          </a>
        </p>
      </RoundContainer>
    </Layout>
  )
}
